import { List, Create, Edit, View, MyPending } from "../Components/index.js";

export default [
    {
        path: "/store/note-sheet",
        component: List,
        name: "store.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/note-sheet/create",
        component: Create,
        name: "store.note-sheet.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/note-sheet/:id/edit",
        component: Edit,
        name: "store.note-sheet.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/note-sheet/:id/view",
        component: View,
        name: "store.note-sheet.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/note-sheet-my-pending",
        component: MyPending,
        name: "store-my-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
